import React from 'react';
import Button from 'components/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {} from './style';

export default function Prompt(props) {
  const [open, setOpen] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby={props.title}
        aria-describedby={props.text}
        disableBackdropClick={props.disableBackdropClick}
      >
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container spacing={1}>
              <Grid item md={12}>
                {props.text}
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.label.map((button) => (
            <Button onClick={() => button.action()} color={button.type}>
              {button.name}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </>
  );
}
